define('common/ko/customBinding/command',['knockout', 'underscore'], function (ko, _) {
    var CommandViewModel = function (command, dispatchCallback) {
        var self = this;
        self.command = ko.observable(command);
        self.dispatchCallback = ko.observable(dispatchCallback);
        self.dispatch = function () {
            return self.command().dispatch(self.dispatchCallback());
        };
        self.dispose = function() {
            //Cleanup here
        };
    };

    ko.bindingHandlers.command = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            if(allBindingsAccessor().dispatch !== undefined) return; //this is probably a command for dispatch (allBindingsAccessor().command in dispatch)
            var tagName = (element.tagName || '').toUpperCase();

            var hiddenSubmit = false;
            if (tagName === 'FORM') {
                 hiddenSubmit = allBindingsAccessor().hiddenSubmit;
            }

            if (hiddenSubmit) {
                var $hiddenSubmit = $('<input type="submit" tabindex="-1" />');
                ko.applyBindingsToNode($hiddenSubmit[0], {style: {
                    'position': 'absolute',
                    'left': '-9999px',
                    'width': '1px',
                    'height': '1px'
                }});
                $(element).append($hiddenSubmit);
            }

            var command = ko.unwrap(valueAccessor());
            var dispatchCallback = ko.unwrap(allBindingsAccessor().dispatchCallback);
            var commandViewModel = new CommandViewModel(command, dispatchCallback);

            var disposables = [];
            disposables.push(commandViewModel);

            ko.utils.domNodeDisposal.addDisposeCallback(element, function() {
                _.invokeMap(disposables, 'dispose');
            });

            ko.utils.domData.set(element, 'commandViewModel', commandViewModel);
            var bindings = {
                'with': commandViewModel.command,
                submit: function () {
                    commandViewModel.dispatch();
                    return false;
                }
            };

            ko.applyBindingsToNode(element, bindings, bindingContext);

            return { controlsDescendantBindings: true };
        },
        update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            if(allBindingsAccessor().dispatch !== undefined) return; //this is probably a command for dispatch (allBindingsAccessor().command in dispatch)
            var commandViewModel = ko.utils.domData.get(element, 'commandViewModel');
            var newCommand = ko.unwrap(valueAccessor());
            var newDispatchCallback = ko.unwrap(allBindingsAccessor().dispatchCallback);
            if (!_.isEqual(newCommand, commandViewModel.command()))
                commandViewModel.command(newCommand);
            if (!_.isEqual(newDispatchCallback, commandViewModel.dispatchCallback()))
                commandViewModel.dispatchCallback(newDispatchCallback);
        }
    };
});

